class PriceStringFormatter {
  static poundsWithCommas(pounds) {
    return (
      (pounds > 0)
        ? pounds.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : pounds
    );
  }

  static getRawRest(roundPrice) {
    let rawRest = roundPrice.toString().split('.')[1] || '00';
    if (rawRest.length < 2) {
      rawRest += '0';
    }
    return rawRest;
  }

  constructor(priceValue, zeroAfterPound = true, showCurrencySign = true, showPenceFraction = false) {
    this.price = Math.abs(priceValue);
    this.negative = Math.sign(priceValue) === -1;
    this.zeroAfterPound = zeroAfterPound;
    this.showPenceFraction = showPenceFraction;
    this.showCurrencySign = showCurrencySign;
  }

  getRoundPrice() {
    let roundBase = this.showPenceFraction ? 1000 : 100;
    if (this.price >= 1) {
      roundBase = 100;
    }
    return Math.round((this.price) * roundBase) / roundBase;
  }

  getPounds() {
    return `${this.getRoundPrice()}`.split('.')[0];
  }

  getPoundsString() {
    return (
      this.getPounds() > 0
        ? `${this.getCurrencySign().prefix}${PriceStringFormatter.poundsWithCommas(this.getPounds())}`
        : ''
    );
  }

  getRest() {
    const rawRest = PriceStringFormatter.getRawRest(this.getRoundPrice());
    if (rawRest[0] === '0' && this.getPounds() === '0') {
      return (rawRest.length === 2) ? rawRest[1] : `${rawRest[1]}.${rawRest[2]}`;
    }
    return this.addFractionDotIfNeeded(`${rawRest}`);
  }

  getRestString() {
    if (this.getRest() === '00' && this.zeroAfterPound === false) {
      return '';
    }
    const restString = this.getRest();
    return (
      this.getPounds() > 0
        ? `.${restString}`.slice(0, 3)
        : `${restString}${this.getCurrencySign().suffix}`
    );
  }

  addFractionDotIfNeeded(restString) {
    return (`${restString}`.length === 3 && this.getPounds() === '0')
      ? `${restString.slice(0, 2)}.${restString.slice(-1)}`
      : restString;
  }

  getCurrencySign() {
    return (this.showCurrencySign) ? { prefix: '£', suffix: 'p' } : { prefix: '', suffix: '' };
  }

  sign() {
    return this.negative ? '-' : '';
  }

  getFormattedPrice() {
    return `${this.sign()}${this.getPoundsString()}${this.getRestString()}`;
  }
}

class PriceStringInPoundsFormatter extends PriceStringFormatter {
  getFractionNeed() { // eslint-disable-line class-methods-use-this
    return false;
  }

  getRestString() {
    if (this.zeroAfterPound) {
      return `.${this.getRest()}`;
    }
    return (this.getRest() === '00') ? '' : `.${this.getRest()}`;
  }

  getRest() {
    return this.addFractionDotIfNeeded(PriceStringFormatter.getRawRest(this.getRoundPrice()));
  }

  getPoundsString() {
    return `${this.getCurrencySign().prefix}${PriceStringFormatter.poundsWithCommas(this.getPounds())}`;
  }
}

export function priceFormatSeparate({
  value,
  zeroAfterPound = true,
  showCurrencySign = true,
  inPound = false,
  showPenceFraction = false,
}) {
  let formatter;
  if (inPound) {
    formatter = new PriceStringInPoundsFormatter(value, zeroAfterPound, showCurrencySign);
  } else {
    formatter = new PriceStringFormatter(value, zeroAfterPound, showCurrencySign, showPenceFraction);
  }
  return [`${formatter.sign()}${formatter.getPoundsString()}`, `${formatter.getRestString()}`];
}

export function priceFormat({
  value,
  zeroAfterPound = true,
  showCurrencySign = true,
  inPound = false,
  showPenceFraction = false,
}) {
  const priceSeparated = priceFormatSeparate({ value, zeroAfterPound, showCurrencySign, inPound, showPenceFraction });
  return `${priceSeparated[0]}${priceSeparated[1]}`;
}
